function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a778f73d-4d7d-4121-b660-7bcc7e568445 {\n        fill: #ff8700;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "a778f73d-4d7d-4121-b660-7bcc7e568445",
  d: "M198.62,0V65.33H264V0Zm44.64,44.65h-24v-24h24v24Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "a778f73d-4d7d-4121-b660-7bcc7e568445",
  points: "307.51 21.78 307.51 0 285.73 0 285.73 43.55 329.28 43.55 329.28 21.78 307.51 21.78 307.51 21.78"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "a778f73d-4d7d-4121-b660-7bcc7e568445",
  points: "394.61 174.22 394.61 152.44 351.06 152.44 351.06 217.77 394.61 217.77 394.61 196 372.83 196 372.83 174.22 394.61 174.22 394.61 174.22"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "a778f73d-4d7d-4121-b660-7bcc7e568445",
  points: "155.06 196 155.06 174.22 133.28 174.22 133.28 217.77 176.84 217.77 176.84 196 155.06 196 155.06 196"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "a778f73d-4d7d-4121-b660-7bcc7e568445",
  points: "416.39 239.55 416.39 217.77 394.61 217.77 394.61 261.34 438.17 261.34 438.17 239.55 416.39 239.55 416.39 239.55"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "a778f73d-4d7d-4121-b660-7bcc7e568445",
  points: "220.39 152.44 220.39 130.67 198.62 130.67 198.62 174.22 242.17 174.22 242.17 152.44 220.39 152.44 220.39 152.44"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "a778f73d-4d7d-4121-b660-7bcc7e568445",
  points: "220.39 108.89 220.39 130.67 242.17 130.67 242.17 87.11 198.62 87.11 198.62 108.89 220.39 108.89 220.39 108.89"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "a778f73d-4d7d-4121-b660-7bcc7e568445",
  points: "89.72 108.89 89.72 152.44 111.5 152.44 111.5 87.11 67.94 87.11 67.94 108.89 89.72 108.89 89.72 108.89"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "a778f73d-4d7d-4121-b660-7bcc7e568445",
  points: "176.84 108.89 176.84 87.11 133.28 87.11 133.28 152.44 155.06 152.44 155.06 174.22 176.84 174.22 176.84 130.67 155.06 130.67 155.06 108.89 176.84 108.89 176.84 108.89"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "a778f73d-4d7d-4121-b660-7bcc7e568445",
  points: "307.51 217.77 307.51 196 285.73 196 285.73 261.34 307.51 261.34 307.51 239.55 329.28 239.55 329.28 261.34 351.06 261.34 351.06 217.77 307.51 217.77 307.51 217.77"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "a778f73d-4d7d-4121-b660-7bcc7e568445",
  points: "394.61 87.11 372.83 87.11 372.83 65.33 351.06 65.33 351.06 130.67 372.83 130.67 372.83 108.89 394.61 108.89 394.61 87.11 394.61 87.11"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "a778f73d-4d7d-4121-b660-7bcc7e568445",
  points: "459.95 174.22 438.17 174.22 438.17 152.44 416.39 152.44 416.39 217.77 438.17 217.77 438.17 196 459.95 196 459.95 174.22 459.95 174.22"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "a778f73d-4d7d-4121-b660-7bcc7e568445",
  points: "245.83 217.77 263.95 217.77 263.95 196 198.62 196 198.62 217.77 216.74 217.77 197.75 261.34 220.55 261.34 231.28 236.73 242.01 261.34 264.82 261.34 245.83 217.77 245.83 217.77"
}), /*#__PURE__*/React.createElement("path", {
  className: "a778f73d-4d7d-4121-b660-7bcc7e568445",
  d: "M307.51,128.81a32.67,32.67,0,1,0-21.78,0v23.63H264v21.78h65.33V152.44H307.51V128.81Zm-10.9-43.88A13.07,13.07,0,1,1,283.54,98a13.07,13.07,0,0,1,13.07-13.07Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a778f73d-4d7d-4121-b660-7bcc7e568445",
  d: "M144.17,0a32.67,32.67,0,1,0,32.67,32.67A32.67,32.67,0,0,0,144.17,0Zm0,45.74a13.07,13.07,0,1,1,13.06-13.07,13.07,13.07,0,0,1-13.06,13.07Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "a778f73d-4d7d-4121-b660-7bcc7e568445",
  points: "35.28 74.04 0 152.44 23.1 152.44 35.28 121.96 47.47 152.44 70.56 152.44 35.28 74.04 35.28 74.04"
}));

function SvgSfacLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f6f23eb6-7ce1-402b-9317-4defe0d32f28",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 459.95 261.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSfacLogo);
export default __webpack_public_path__ + "static/media/sfac_logo.b0a328f4.svg";
export { ForwardRef as ReactComponent };